import {SchemaTag, Tag} from 'folder-items/FileConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {filterToSchemaTags} from 'schemas/tags/TagUtil';
import {Optional} from 'util/Types';

import {AssayResult, AssayRun} from './AssayRecordConstants';

export function getTagForField(
  record: AssayResult | AssayRun,
  fieldId: Optional<number>
): Optional<SchemaTag> {
  return fieldId ? filterToSchemaTags(record.allTags).find((tag) => tag.tagSchemaField.id === fieldId) : null;
}

export function getTagsForFields(fields: Array<SchemaField>, tags: Array<Tag>): Array<SchemaTag> {
  const fieldIds = fields.map((field) => field.id);
  return filterToSchemaTags(tags).filter((tag) => fieldIds.includes(tag.tagSchemaField.id));
}
